'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAPSVideoBid = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getAds = getAds;

var _sessionViews = require('./session-views');

var _sessionViews2 = _interopRequireDefault(_sessionViews);

var _loggingUtil = require('./logging-util');

var _mobileUtil = require('./mobile-util');

var _mobileUtil2 = _interopRequireDefault(_mobileUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchAPSVideoBid = exports.fetchAPSVideoBid = function fetchAPSVideoBid() {
  return new Promise(function (resolve) {
    try {
      if (!(window && window.apstag && window.apstag.fetchBids)) {
        return resolve('');
      }

      window.apstag.fetchBids({
        slots: [{
          slotID: 'Hudl_Video',
          mediaType: 'video'
        }],
        timeout: 2000
      }, function (bids) {
        var bid = bids.length > 0 ? bids[0].qsParams : '';
        return resolve(bid);
      });
    } catch (e) {
      console.error('Error fetching APS video bid', e);
      return resolve('');
    }
  });
};

// cust_params is used to pass addition information about the user or page to the ad server.
function applyAdBid(ad, bid) {
  if (bid === '') {
    return ad;
  }

  try {
    var url = new URL(ad.src);
    var searchParams = url.searchParams;

    searchParams.set('cust_params', '' + (searchParams.get('cust_params') || '') + bid);

    url.search = searchParams.toString();
    var updatedUrl = url.toString();

    return _extends({}, ad, {
      src: updatedUrl
    });
  } catch (e) {
    return ad;
  }
}

function generateVastTag(baseTag, custParams) {
  var descriptionUrl = encodeURIComponent(document.URL);
  var timestamp = encodeURIComponent(new Date().getTime());

  var tag = baseTag.replace('[timestamp]', timestamp).replace('[referrer_url]', descriptionUrl).replace('[description_url]', descriptionUrl);

  if (custParams.nonPersonalizedAds) {
    tag = tag + '&npa=1';
  }

  if (custParams) {
    var paramsObj = _extends({}, custParams);
    var paramsArr = [];

    Object.keys(paramsObj).forEach(function (key) {
      if (key === 'nonPersonalizedAds') {
        return;
      }

      if (key === 'adContext') {
        if (paramsObj[key]) {
          paramsArr.push(paramsObj[key]);
        }
      } else {
        // Only include key=value if value is not null or undefined
        if (paramsObj[key] !== null && paramsObj[key] !== undefined) {
          paramsArr.push(key + '=' + paramsObj[key]);
        }
      }
    });

    var params = paramsArr.join('&');
    var encoded = encodeURIComponent(params);
    tag = tag + '&cust_params=' + encoded;
  }

  return tag;
}

function getAds(adTag, durationMs, headerBid) {
  var ads = null;
  var isMobile = _mobileUtil2.default.isMobileOrTablet();
  if (adTag && adTag.preRollAdData) {
    var vastTagKey = isMobile && adTag.mobileVastTag || adTag.vastTag;
    if (vastTagKey) {
      var referrerRoot = (0, _loggingUtil.getReferrerRoot)(document.referrer);

      adTag.preRollAdData.viewCount = _sessionViews2.default.get();
      adTag.preRollAdData.referrerRoot = referrerRoot;
      if (durationMs) {
        // DFP param is configured in seconds
        adTag.preRollAdData.reelLength = Math.round(durationMs / 1000);
      }

      var tag = generateVastTag(vastTagKey, adTag.preRollAdData);
      var ad = { src: tag, type: 'vast' };
      if (headerBid && headerBid.length > 0) {
        ad = applyAdBid(ad, headerBid);
      }

      ads = [ad];
    }
  }

  return ads;
}